function toggleLogIn () {
  const btn = document.querySelector('.header-menu .menu-section.right-menu .account-login .accor-button.login input');

  if (btn) {
    btn.click();
    btn.closest('.account-dropdown').style.display="none";
  }
}

function toggleSignUp () {
  const btn = document.querySelector('.header-menu .menu-section.right-menu .account-login .accor-button.register input');

  if (btn) {
    btn.click();
    btn.closest('.account-dropdown').style.display="none";
  }
}

export {
  toggleLogIn,
  toggleSignUp
}
